export default class FileDataViewModel {
    public id: number = 0;
    public assetId: number = 0;
    public dateAdded: Date = new Date();
    public fileName: string = '';
    public fileType: string = '';
}